import { CouldNotParse } from 'components/ordering/checkout/payment-methods/payment-backend/could-not-parse.js'
import { PAYMENT_URL_MUTATOR, PaymentUrlMutator } from './payment-url-store.js'
import { CSCPaymentMethod } from 'components/ordering/checkout/payment-methods/methods/payment-method.js'
import { GET_PAYMENT_METHODS_API, GetPaymentMethodsApi, GetPaymentMethodsRequest } from './get-payment-methods-api.js'

import {
  parseMollieApiUrls,
  parseMolliePaymentMethods,
  parseOnAccountApiUrls,
  parseOnAccountPaymentMethod,
  parseOverruleApiUrls,
  parseOverrulePaymentMethods,
} from './get-payment-methods-parser.js'
import { FAKE, inject, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'


export const GET_PAYMENT_METHODS_BACKEND = Symbol('PAYMENT_METHODS_BACKEND')


@registerDependency(FAKE, GET_PAYMENT_METHODS_BACKEND)
@registerDependency(REAL, GET_PAYMENT_METHODS_BACKEND)
export class GetPaymentMethodsBackend {
  @inject(GET_PAYMENT_METHODS_API)
  private paymentMethodsApi!: GetPaymentMethodsApi

  @inject(PAYMENT_URL_MUTATOR)
  private paymentUrlMutator!: PaymentUrlMutator

  getPaymentMethods = async (payloadOrPath: unknown): Promise<CSCPaymentMethod[]> => {
    const response = typeof payloadOrPath === 'string'
      ? await this.paymentMethodsApi.getPaymentMethods(
        new GetPaymentMethodsRequest(new URL(payloadOrPath, window.location.origin)),
      )
      : payloadOrPath

    const mollieApiUrls = parseMollieApiUrls(response)
    const onAccountApiUrls = parseOnAccountApiUrls(response)
    const overruleApiUrls = parseOverruleApiUrls(response)
    const molliePaymentMethods = parseMolliePaymentMethods(response)
    const onAccountPaymentMethod = parseOnAccountPaymentMethod(response)
    const overrulePaymentMethods = parseOverrulePaymentMethods(response)

    if (mollieApiUrls !== CouldNotParse) {
      this.paymentUrlMutator.setMollieUrls(
        mollieApiUrls.startPaymentUrl,
        mollieApiUrls.selectPaymentMethodUrl,
      )
    }

    if (onAccountApiUrls !== CouldNotParse) {
      this.paymentUrlMutator.setOnAccountUrls(
        onAccountApiUrls.startPaymentUrl,
        onAccountApiUrls.selectPaymentMethodUrl,
      )
    }

    if (overruleApiUrls !== CouldNotParse) {
      this.paymentUrlMutator.setOverruleUrls(
        overruleApiUrls.startPaymentUrl,
        overruleApiUrls.selectPaymentMethodUrl,
      )
    }

    const paymentMethods: CSCPaymentMethod[] = []

    if (molliePaymentMethods !== CouldNotParse) {
      paymentMethods.push(...molliePaymentMethods)
    }

    if (onAccountPaymentMethod !== CouldNotParse) {
      paymentMethods.push(onAccountPaymentMethod)
    }

    paymentMethods.push(...overrulePaymentMethods)

    return paymentMethods
  }
}
